import React from 'react';
import './WhyThisSchool.css';
import { useEffect } from 'react';
function WhyThisSchool() {
  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to the top of the page
  }, []);
  return (
    <div className="why-container">
      <div className="why-section">
        <h2 className="why-heading">Why This School</h2>
        <p className="why-paragraph">
          At Oxford English High School, we are dedicated to providing an education that nurtures both the mind and the character. Here's why our school stands out as a top choice for your child’s educational journey:
        </p>
        <ul className="why-list">
          <li>
            <strong>Holistic Development:</strong> We believe in educating the whole child. Our approach balances academic rigor with co-curricular activities, helping students develop not just intellectually, but also socially, emotionally, and creatively.
          </li>
          <li>
            <strong>Experienced and Caring Faculty:</strong> Our teachers are highly qualified, experienced, and deeply committed to the success and well-being of every student. They go beyond textbooks to inspire a love of learning and support each child’s individual strengths and needs.
          </li>
          <li>
            <strong>Innovative Curriculum:</strong> We follow a dynamic curriculum that is designed to provide a strong academic foundation while fostering critical thinking, problem-solving, and creativity. Our students are prepared to meet the challenges of an ever-evolving world.
          </li>
          <li>
            <strong>State-of-the-Art Facilities:</strong> Our school offers modern infrastructure, including well-equipped classrooms, science and computer labs, libraries, and sports facilities, providing an ideal environment for learning and growth.
          </li>
          <li>
            <strong>Focus on Values and Character Building:</strong> At Oxford, education is not just about academic achievement; it’s about instilling values like discipline, respect, integrity, and empathy. We aim to shape responsible, compassionate citizens who contribute positively to society.
          </li>
          <li>
            <strong>Strong Parent-Teacher Partnership:</strong> We believe that education is a collaborative effort between school and home. We maintain open communication with parents, ensuring they are actively involved in their child’s academic progress and personal development.
          </li>
          <li>
            <strong>Co-Curricular Excellence:</strong> From sports and arts to music and drama, we encourage students to explore their talents beyond the classroom. These activities are integral in fostering teamwork, creativity, and leadership skills.
          </li>
        </ul>
        <p className="why-paragraph">
          Choosing Oxford Convent English Medium School means investing in an environment where your child’s potential is recognized, nurtured, and celebrated. We are proud to guide students towards becoming not only successful learners but also well-rounded individuals ready to face the future with confidence.
        </p>
        <p className="why-paragraph">
          Join us at Oxford Convent English Medium School — where excellence in education meets a commitment to building the leaders of tomorrow!
        </p>
      </div>
    </div>
  );
}

export default WhyThisSchool;
